module.exports = require("@swa-ui/vacations/src/ManageMyVacationsFlyout/ManageMyVacationsFlyout.module.scss");